<template>
  <v-container fluid style="position: relative; padding-top: 0">
    <v-container style="padding-top: 0">
      <v-card tile>
        <v-container class="main__header">
          <v-card-title
            style="
              padding: 15px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <v-col style="display: flex; align-items: center; padding: 0">
              {{ $t("BASchedule") }}

              <v-btn
                icon
                :disabled="loading || !currentDay || !viewDay"
                class="ml-3"
                @click="scrollToCurrentTime"
                :title="$t('toCurrentTime')"
              >
                <v-icon>mdi-arrow-down-bold-circle</v-icon>
              </v-btn>

              <v-btn
                icon
                :disabled="loading"
                @click="reloadSummary"
                :title="$t('reloadSummary')"
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>

              <v-btn
                icon
                :disabled="loading"
                @click.stop="showEmptyForm"
                :title="$t('BAFormBook')"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <booking-admin-form
                :sessionSlot="sessionSlot"
                :selectedDay="selectedDay"
                :dialogForm="dialogForm"
                @close-form="dialogForm = false"
                @close-dialog="closeDialog"
                @visible-alert="visibleAlert"
              >
              </booking-admin-form>

              <v-btn
                icon
                :disabled="loading"
                @click.stop="dialogFormMulti = true"
                :title="$t('BAFormBookMulti')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M2 12c0-2.8 1.6-5.2 4-6.3V3.5C2.5 4.8 0 8.1 0 12s2.5 7.2 6 8.5v-2.2c-2.4-1.1-4-3.5-4-6.3m13-9c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m5 10h-4v4h-2v-4h-4v-2h4V7h2v4h4v2Z"
                  />
                </svg>
              </v-btn>
              <v-dialog v-model="dialogFormMulti" persistent width="1400">
                <booking-admin-form-multi
                  :selectedDay="selectedDay"
                  :dialogFormMulti="dialogFormMulti"
                  @close-form="dialogFormMulti = false"
                  @close-dialog="closeDialog"
                  @visible-alert="visibleAlert"
                >
                </booking-admin-form-multi>
              </v-dialog>

              <v-btn
                icon
                :disabled="loading"
                @click.stop="dialogSearch = true"
                :title="$t('navSearch')"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <search-modal
                :dialogSearch="dialogSearch"
                @close-modal="dialogSearch = false"
              >
              </search-modal>

              <v-btn
                v-if="location.id === 1"
                icon
                @click.stop="paymentForm = true"
                @reload-payments="false"
                :title="$t('paymentFormTitle')"
                :disabled="loading"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15 15v2h3v3h2v-3h3v-2h-3v-3h-2v3m-3.03-3.39C14.85 10.28 13.59 8.97 12 9c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16M13 16H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3v12h10.32a6.38 6.38 0 0 1-.32-2Z"
                  />
                </svg>
              </v-btn>
              <payments-form
                :paymentForm="paymentForm"
                @close-dialog="paymentForm = false"
              ></payments-form>

              <v-switch
                style="margin-top: 10px; margin-left: 10px"
                v-model="archive"
                inset
                color="red"
                :label="$t('BAShowArchieved')"
                dense
                @change="reloadSummary"
                :disabled="loading"
              ></v-switch>
            </v-col>
            <div class="location-name">
              <h4 class="text-h4">{{ location.name }}</h4>
            </div>
          </v-card-title>
          <v-container
            v-if="!loading && viewDay"
            style="
              position: relative;
              top: 77px;
              left: 24px;
              height: 30px;
              width: 100%;
              z-index: 11;
              max-width: 1688px;
              padding: 0;
            "
          ></v-container>
          <div v-if="!loading && viewDay" class="progress-bar">
            <v-row no-gutters>
              <v-col v-for="item in progressLinear" :key="item.id">
                <v-progress-linear
                  style="border: solid 1px cadetblue"
                  color="#3e92d1"
                  v-model="item.progress"
                  height="25"
                >
                  <strong>{{ item.orderCount }}</strong>
                </v-progress-linear>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <OrderInformationModal
          :alert="alert"
          @close-alert="alert = false"
        ></OrderInformationModal>

        <v-dialog v-if="dialogOrder" v-model="dialogOrder" max-width="1200px">
          <v-card tile style="min-height: 415px">
            <v-container class="py-0">
              <booking-admin-multi-order
                v-for="(order, k) in sessionSlot.orders"
                :key="k"
                :order="order"
                :comments="comments"
                :sessionSlot="sessionSlot"
                :selectedDay="selectedDay"
                @change-order="emitingOrderManipulation"
                @remove-order="emitingOrderManipulation"
                @pay-order="emitingOrderManipulation"
              ></booking-admin-multi-order>
            </v-container>
          </v-card>
        </v-dialog>

        <v-card
          class="v-card--hover"
          tile
          v-if="loading"
          style="
            position: fixed;
            top: 65px;
            width: 100%;
            height: 2000px;
            z-index: 10;
            opacity: 0;
          "
        >
          <div class="text-center">
            <v-dialog
              v-model="dialogLoading"
              hide-overlay
              persistent
              width="500"
            >
              <v-card color="#42b983" dark>
                <v-card-text>
                  {{ $t("BAStandBy") }}
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </v-card>

        <calendar
          :timeFrom="timeFrom"
          :timeTo="timeTo"
          :events="events"
          :events2="events2"
          :selectedDate1="selectedDate1"
          :selectedDate2="selectedDate2"
          :selectedView1="selectedView1"
          :selectedView2="selectedView2"
          :loading="loading"
          @open-dialog-order="dialogOrder = true"
          @open-dialog-form="dialogForm = true"
          @on-event-click="onEventClick"
          @debounce-change-cal="changeCal"
        >
        </calendar>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import BookingAdminItem from "@/components/BookingAdminItem.vue";
import BookingAdminForm from "@/components/BookingAdminForm.vue";
import BookingAdminFormMulti from "@/components/BookingAdminFormMulti.vue";
import BookingAdminMultiOrder from "@/components/BookingAdminMultiOrder.vue";
import OrderInformationModal from "@/components/OrderInformationModal";
import PaymentsForm from "@/components/PaymentsForm.vue";
import Calendar from "@/components/Calendar";
import SearchModal from "@/components/SearchModal";
import store from "../store";

export default {
  name: "MultiBookingAdmin",

  components: {
    SearchModal,
    BookingAdminItem,
    BookingAdminForm,
    BookingAdminFormMulti,
    BookingAdminMultiOrder,
    OrderInformationModal,
    PaymentsForm,
    Calendar,
  },

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  async created() {
    this.debounceChangeCal = this.debounce(this.changeCal, 500);
    await this.reloadSummary();
    this.scrollToCurrentTime();
  },

  mounted() {
    const selectedId = window.localStorage.getItem("selected_pg_id");
    this.selectedPlayground =
      this.location.playgrounds.find((pg) => pg.id === selectedId) ??
      this.location.playgrounds[0];
  },

  data() {
    return {
      progressLinear: [],
      loading: false,
      dialogLoading: true,
      timeFrom: null,
      timeTo: null,
      timeStartArr: [],
      timeEndArr: [],
      events: [],
      events2: [],
      selectedPlayground: null,
      alert: false,
      paymentForm: false,
      archive: true,
      groupedSchedule: [],
      selectedDay: moment().format("YYYY-MM-DD"),
      selectedDate1: moment().format("YYYY-MM-DD"),
      selectedDate2: moment().format("YYYY-MM-DD"),
      selectedView1: "day",
      selectedView2: "day",
      currentDay: true,
      viewDay: true,
      dialogForm: false,
      dialogFormMulti: false,
      dialogOrder: false,
      dialogSearch: false,
      sessionSlot: {
        time_start: null,
        playground: null,
        pricing: {},
        orders: [],
      },
      comments: null,
      debounceChangeCal: null,
    };
  },

  computed: {
    ...mapGetters([
      "location",
      "summary",
      "BASchedule",
      "orderId",
      "errorMessage",
    ]),
    formattedDate() {
      let itemBeginHours = moment
        .parseZone(this.sessionSlot.start)
        .format("HH");

      if (itemBeginHours >= 6 && itemBeginHours <= 23) {
        return this.sessionSlot
          ? moment.parseZone(this.sessionSlot.start).format("DD.MM.YYYY")
          : "";
      } else {
        return this.sessionSlot
          ? moment
              .parseZone(this.sessionSlot.start)
              .add(1, "day")
              .format("DD.MM.YYYY")
          : "";
      }
    },
    playgrounds() {
      return this.location.playgrounds.filter((e) => {
        return (
          e.types === "the_cube" || e.types === "arena" || e.types === "lounge"
        );
      });
    },
  },

  methods: {
    ...mapActions(["loadBASchedule", "loadBAOrderComments"]),
    async reloadSummary() {
      this.loading = true;
      this.events = [];
      this.events2 = [];
      this.timeStartArr = [];
      this.timeEndArr = [];
      this.progressLinear = [];
      this.sortPlaygrounds("playground", true);

      for (const playground of this.playgrounds) {
        await this.loadSummaryItem(playground.id);
      }

      this.loading = false;
      let timeStart = Math.min.apply(null, this.timeStartArr);
      let timeEnd = Math.max.apply(null, this.timeEndArr);
      this.timeFrom = timeStart * 60;
      this.timeTo = (timeEnd + 1) * 60;
      this.addBorderForSlots();
    },
    async loadSummaryItem(playgroundId) {
      await this.loadSchedule(this.selectedDate1, playgroundId);
      this.groupProgressLinear(playgroundId);
      let timeGrouped = [];

      this.groupedSchedule.forEach((item) => {
        let itemBeginHours = moment.parseZone(item.begin).format("HH");
        timeGrouped.push(Number(itemBeginHours));

        if (itemBeginHours >= 6 && itemBeginHours <= 23 && item.orders.length) {
          this.events.push({
            start: moment.parseZone(item.begin).format("YYYY-MM-DD HH:mm"),
            end: moment
              .parseZone(item.end)
              .add(1, "minutes")
              .format("YYYY-MM-DD HH:mm"),
            split: playgroundId,
            pricing: item.pricing,
            available_persons: item.available_persons,
            orders: item.orders,
            id: item.orders[0].id,
            name: item.orders[0].name,
            persons: item.orders[0].persons,
            content: item.orders[0],
          });
        } else if (itemBeginHours >= 6 && itemBeginHours <= 23) {
          this.events.push({
            start: moment.parseZone(item.begin).format("YYYY-MM-DD HH:mm"),
            end: moment
              .parseZone(item.end)
              .add(1, "minutes")
              .format("YYYY-MM-DD HH:mm"),
            split: playgroundId,
            pricing: item.pricing,
            available_persons: item.available_persons,
            orders: false,
            id: " ",
            name: " ",
            persons: " ",
            content: " ",
          });
        } else if (itemBeginHours < 6 && item.orders.length) {
          this.events2.push({
            start: moment
              .parseZone(item.begin)
              .subtract(1, "day")
              .format("YYYY-MM-DD HH:mm"),
            end: moment
              .parseZone(item.end)
              .subtract(1, "day")
              .add(1, "minutes")
              .format("YYYY-MM-DD HH:mm"),
            split: playgroundId,
            pricing: item.pricing,
            available_persons: item.available_persons,
            orders: item.orders,
            id: item.orders[0].id,
            name: item.orders[0].name,
            persons: item.orders[0].persons,
            content: item.orders[0],
          });
        } else if (itemBeginHours < 6) {
          this.events2.push({
            start: moment
              .parseZone(item.begin)
              .subtract(1, "day")
              .format("YYYY-MM-DD HH:mm"),
            end: moment
              .parseZone(item.end)
              .subtract(1, "day")
              .add(1, "minutes")
              .format("YYYY-MM-DD HH:mm"),
            split: playgroundId,
            pricing: item.pricing,
            available_persons: item.available_persons,
            orders: false,
            id: " ",
            name: " ",
            persons: " ",
            content: " ",
          });
        }
      });
      this.getStartEndTimeSchedule(timeGrouped);
    },
    async loadSchedule(date, id) {
      let self = this;
      self.selectedDay = date;
      await self.loadBASchedule({
        playground_id: id,
        selected_date: moment.parseZone(date).format("YYYY-MM-DD"),
      });
      let availableScheduleData = [];
      self.BASchedule.forEach((el) => {
        if (self.archive) {
          availableScheduleData.push(el);
        } else {
          if (
            !moment
              .parseZone(el.begin)
              .add(self.selectedPlayground.duration, "m")
              .isBefore(moment.parseZone())
          ) {
            availableScheduleData.push(el);
          }
        }
      });
      self.groupedSchedule = availableScheduleData;
    },
    groupByPrice(schedule) {
      let self = this;
      return schedule.reduce((rv, x) => {
        let isFree,
          isPending,
          isPaid,
          isNotPaid,
          isNeedPaid,
          isArchived,
          isEvent;
        if (x.orders) {
          isPending = x.orders.find((el) => {
            return el.status == 2;
          })
            ? true
            : false;
          isEvent = x.orders.find((el) => el.order_type === 4);

          if (isPending) {
            isFree = false;
            isPaid = false;
            isNeedPaid = false;
            isNotPaid = false;
          } else {
            isNotPaid = x.orders.find((el) => {
              return (
                el.paid == 0 &&
                el.purchase > 0 &&
                el.order_type !== 2 &&
                el.order_type !== 3
              );
            })
              ? true
              : false;

            if (isNotPaid) {
              isFree = false;
              isPaid = false;
              isNeedPaid = false;
            } else {
              isFree = x.orders.find((el) => {
                return el.order_type == 3 || el.order_type == 2;
              })
                ? true
                : false;
              isPaid = x.orders.find((el) => {
                return el.status == 6;
              })
                ? true
                : false;
              isNeedPaid = !!x.orders.find((el) => {
                return el.need_paid > 0 && el.paid > 0;
              });
            }
          }
        }

        isArchived = moment
          .parseZone(x.begin)
          .add(self.selectedPlayground.duration, "m")
          .isBefore(moment.parseZone())
          ? true
          : false;

        (rv[x["pricing"]["session_price"]] =
          rv[x["pricing"]["session_price"]] || []).push(
          Object.assign(
            {
              isFree: isFree,
              isPending: isPending,
              isNotPaid: isNotPaid,
              isNeedPaid: isNeedPaid,
              isPaid: isPaid,
              isArchived: isArchived,
              isEvent: isEvent,
            },
            x
          )
        );
        return rv;
      }, {});
    },
    sortPlaygrounds() {
      this.location.playgrounds.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    getStartEndTimeSchedule(timeGrouped) {
      this.timeStartArr.push(
        Math.min.apply(
          null,
          timeGrouped.filter((t) => t >= 6 && t <= 23)
        )
      );
      this.timeEndArr.push(
        Math.max.apply(
          null,
          timeGrouped.filter((t) => t < 6)
        )
      );
    },
    groupProgressLinear(playgroundId) {
      const allCountSchedule = this.groupedSchedule.length;
      const bookedSlot = this.groupedSchedule.filter(
        (slot) => slot.available_persons === 0
      ).length;
      const progress = 100 - (bookedSlot / allCountSchedule) * 100;
      const orderCount = allCountSchedule - bookedSlot;
      this.progressLinear.push({
        progress: progress,
        orderCount: orderCount,
        id: playgroundId,
      });
    },
    showEmptyForm() {
      this.sessionSlot = {
        time_start: null,
        playground: null,
        pricing: {},
        orders: [],
      };
      this.dialogForm = true;
    },
    onEventClick(e) {
      this.sessionSlot = {
        start: e.start,
        time_start: moment.parseZone(e.start).format("HH:mm"),
        playground: e.split,
        pricing: e.pricing,
        orders: e.orders,
        available_persons: e.available_persons,
      };
      this.loadOrderComments(e.orders);
    },
    async loadOrderComments(orders) {
      if (orders.length) {
        const acc = {};
        for (const order of orders) {
          const result = await this.loadBAOrderComments(order.id);
          acc[order.id] = result.data;
        }
        this.comments = acc;
      }
    },
    async emitingOrderManipulation() {
      this.dialogOrder = false;
      await this.reloadSummary();
    },
    debounce(fn, wait) {
      let timer;
      return function (...args) {
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          fn.apply(context, args);
        }, wait);
      };
    },
    async changeCal($event) {
      if ($event.view === "day") {
        this.selectedDate1 = $event.startDate;
        this.selectedView1 = $event.view;
        this.selectedDate2 = $event.startDate;
        this.selectedView2 = $event.view;
        this.viewDay = true;
        const today = moment(new Date());
        this.currentDay =
          moment(today).format("YYYY-MM-DD") ===
          moment(this.selectedDate1).format("YYYY-MM-DD");
        await this.reloadSummary();
        this.scrollToCurrentTime();
      } else {
        this.selectedView1 = $event.view;
        this.selectedView2 = $event.view;
        this.viewDay = false;
      }
    },
    visibleAlert() {
      this.alert = true;
    },
    closeDialog() {
      if (this.orderId !== null) {
        this.reloadSummary();
        this.dialogForm = false;
        this.dialogFormMulti = false;
      }
    },
    scrollToCurrentTime() {
      if (this.currentDay) {
        const el = document.getElementsByClassName("vuecal__now-line");
        const datetimeNow = new Date();
        const hours = datetimeNow.getHours();
        if (hours >= 0 && hours < 6) {
          el[1].scrollIntoView({
            block: "center",
            inline: "center",
            behavior: "smooth",
          });
        }
        if (hours > 6 && hours < 24) {
          el[0].scrollIntoView({
            block: "center",
            inline: "center",
            behavior: "smooth",
          });
        }
      }
    },
    addBorderForSlots() {
      const slots = document.querySelectorAll(".vuecal__event");

      slots.forEach((slot) => {
        const bookBtn = slot.querySelector("#book_btn");
        return bookBtn ? "" : (slot.style.border = "solid 2px red");
      });
    },
  },
};
</script>

<style>
.main__header {
  position: fixed;
  z-index: 2;
  width: 100%;
  max-width: 1749px;
  padding-right: 0;
  padding-bottom: 0;
  background-color: #fff;
}

.progress-bar {
  position: relative;
  z-index: 10;

  top: 50px;
  left: 47px;

  width: 91.9%;
  padding: 0;

  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
}

.location-name {
  padding-right: 100px;
}

.container {
  max-width: 1785px;
  padding-left: 30px;
}

@media (max-width: 1163px) {
  .container {
    padding-left: 12px;
  }
}

@media (max-width: 1800px) {
  .progress-bar {
    width: 91.7%;
  }
}

@media (max-width: 1750px) {
  .progress-bar {
    width: 91.5%;
  }
}

@media (max-width: 1650px) {
  .progress-bar {
    width: 91%;
    font-size: 14px;
  }
  .day-split-header {
    font-size: 14px !important;
  }
}

@media (max-width: 1600px) {
  .location-name .text-h4 {
    font-size: 28px !important;
  }
}

@media (max-width: 1550px) {
  .progress-bar {
    width: 90.5%;
  }
}

@media (max-width: 1450px) {
  .progress-bar {
    width: 90%;
  }
}

@media (max-width: 1400px) {
  .progress-bar {
    width: 89.5%;
  }
  .location-name .text-h4 {
    font-size: 18px !important;
  }
  .day-split-header {
    font-size: 12px !important;
  }
}

@media (max-width: 1350px) {
  .progress-bar {
    width: 89%;
  }
}

@media (max-width: 1300px) {
  .progress-bar {
    width: 88.5%;
  }
}

@media (max-width: 1250px) {
  .progress-bar {
    width: 88%;
  }
  .day-split-header {
    font-size: 10px !important;
  }
}
</style>
